import { memo } from "react";
import { View } from "react-native";
import cursor from "src/constants/cursor";
import native from "src/constants/native";
import usePalette from "src/hooks/usePalette";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { radiusMedium } from "src/styles/radius";
import { paddingLarge } from "src/styles/spacing";
import { Link } from "src/swsh-native";
import GatheringPreviewInfo from "./components/GatheringPreviewInfo";
import GatheringThumbnailPreview from "./components/GatheringThumbnailPreview";
import { GatheringPreviewCardProps } from "./types";

const PhotoContainerRadius = radiusMedium;
const GatheringPreviewCard = ({
	gathering,
	style,
	testID,
	details = ["numParticipants", "numPhotos", "numComments"],
	variant = "Default",
	ringPreferPalette,
}: GatheringPreviewCardProps) => {
	const { theme } = useStyle();
	const href = native ? `/album/${gathering?.gatheringId}` : `/album/${gathering?.refCode}`;
	const isEmpty = variant === "Empty" || !gathering;
	const { secondary, isFallback } = usePalette();

	return (
		<View
			style={[
				{
					cursor: isEmpty ? cursor.default : cursor.pointer,
					backgroundColor: isFallback ? color.BackgroundCard[theme] : secondary,
					borderRadius: PhotoContainerRadius,
					overflow: "hidden",
					paddingHorizontal: paddingLarge,
					columnGap: paddingLarge,
				},
				style,
				{
					flexDirection: "row",
					alignItems: "center",
				},
			]}
			testID={testID}
		>
			{!isEmpty && (
				<>
					<Link
						href={href}
						style={{
							position: "absolute",
							top: 0,
							left: 0,
							bottom: 0,
							right: 0,
						}}
					>
						<></>
					</Link>

					<GatheringThumbnailPreview
						gathering={gathering}
						preferPalette={ringPreferPalette}
					/>
					<GatheringPreviewInfo gathering={gathering} details={details} href={href} />
				</>
			)}
		</View>
	);
};
export default memo(GatheringPreviewCard);
